module.exports = __webpack_public_path__ + "static/img/case_banner_03.f7348be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_03.png
// module id = GhU4
// module chunks = 34